export default "__VITE_ASSET__BxEpddw9__"